import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import '../Listing.style.scss'
import Smoobu from "../../../components/Smoobu/Smoobu.component";
import ImagesContainer from "../components/ImagesContainer/ImagesContainer.component";
import ImagesModal from "../components/ImagesModal/ImagesModal.component";
import { VillaCoralSnippet } from "../../../utils/constants";
import { HouseDataType } from "../../../utils/types";
import Amenities from "../components/Amenities/Amenities.component";
import { AmenityType } from "../../../utils/types";
import { VillasDataListES } from "../../../utils/constants";
import { Helmet } from "react-helmet";
import { useMediaQuery } from '@react-hook/media-query';
import MessageTipContainer from "../../../components/MessageTip/MessageTipContainer.component";
import { useSmoobuBookingTip } from "../../../hooks/useSmoobuBookingTip";
import OtherListingsES from "../components/OtherListings/OtherListings.componentES";
import FixedNavigationRibES from "../../../components/FixedNavigation/FixedNavigation.componentRIBES";
import ListingMarketingSection from "../../../components/ListingMarketingSection/ListingMarketingSection.component";
import PriceConfirmationSection from "../../../components/PriceConfirmationSection/PriceConfirmationSection.component";
import SocialStatement from "../../../components/SocialStatement/SocialStatement.component";
import FeatureHighlights from "../../../components/FeatureHighlights/FeatureHighlights.component";
import { useSmoobuMobileScrollTip } from "../../../hooks/useSmoobuMobileScrollTip";


const ListingVillaCoralES = () => {
    const listing = 'Villa CoralES'
    const isScreenSmall = useMediaQuery('(max-width: 992px)');

    const [show, setShow] = useState(false);
    // Show booking encouragement tip when user interacts with Smoobu widget
    useSmoobuBookingTip({ isSpanishPage: true, propertyName: 'Villa Coral' });
    useSmoobuMobileScrollTip({
        isSpanishPage: true,
        isScreenSmall: isScreenSmall
    });
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const houseData: HouseDataType | undefined = VillasDataListES.find((house) => house.houseLangCode === "VillaCoralES");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    }, [])
    //const description = houseData?.description.split('<br/>');
    //const neighborhood = houseData?.neighborhood.split('<br/>');
    return (
        <div className={`listingContainer ${show && 'modal-open'}`}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Villa Coral - Casa con piscina privada en Playa Chiquita</title>
                <meta name="description" content="Located in the heart of town, this house has space for up to 5 people and features a fully equipped kitchen, a bathroom, 2 A/C units, and a private parking lot." />
                <link rel="canonical" href="https://www.reservaskalawala.com/VillaCoralES" />
                <link rel="alternate" hrefLang="en" href="https://www.reservaskalawala.com/VillaCoral" />
                <link rel="alternate" hrefLang="es" href="https://www.reservaskalawala.com/VillaCoralES" />
                <link rel="alternate" hrefLang="x-default" href="https://www.reservaskalawala.com/VillaCoral" />
            </Helmet>
            <FixedNavigationRibES isBlog={false} />
            {isScreenSmall && (
                <div className="button-hold fixed-bottom sticky-cta-mobile" style={{ paddingBottom: "env(safe-area-inset-bottom);" }}><Button className='btn-darker sticky-cta-button' href="#smoobuComp">VER DISPONIBILIDAD</Button></div>)}

            <Row className="subContainer">
                <Col className="info col" lg={{ order: 'first', span: 10 }} md={{ order: 'first', span: 12 }} sm={12} xs={12}>
                    <div className="heading">
                        <h1 className="title">Villa Coral</h1>
                        <h3 className="location">
                            <a href="https://maps.app.goo.gl/cJa27cXoXunmuNkf7" target="_blank" rel="noopener noreferrer">
                                Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica
                            </a>
                        </h3>
                        {/* Add marketing section after title */}
                        <ListingMarketingSection propertyKey="VillaCoral" isSpanish={true} />
                    </div>
                    <ImagesContainer showModal={handleShow} houseName={listing!} />
                    {/* Add social statement after images */}
                    <SocialStatement propertyKey="VillaCoral" isSpanish={true} />
                    <div className="amenaties">
                        <Amenities amenities={houseData?.amenities as AmenityType[]} />
                    </div>

                    {/* Add feature highlights before description */}
                    <FeatureHighlights propertyKey="VillaCoral" propertyName="Villa Coral" isSpanish={true} />

                    <div className="description">
                        <div className="check-times" style={{ marginBottom: '20px', padding: '15px', borderRadius: '8px' }}>
                            <p><strong>Entrada:</strong> 3:00 PM</p>
                            <p><strong>Salida:</strong> 12:00 PM (mediodía)</p>
                        </div>
                        <p>
                            Descubre el retiro perfecto en Playa Chiquita, Puerto Viejo. Nuestra villa de lujo construida recientemente ofrece una experiencia vacacional ideal, combinando comodidad y conveniencia en un entorno tropical sereno.
                            <br />
                        </p>
                        <p>
                            Mantente conectado con internet de alta velocidad de hasta 100 Mbps y aprovecha el espacio de trabajo dedicado si necesitas atender tareas durante tu visita.
                            <br />
                        </p>
                        <p>
                            La villa, que cuenta con piscina privada, cocina y baño, ha sido decorada por la diseñadora de interiores puertorriqueña Lourdes Menéndez
                            <br />
                        </p>
                        <p>
                            Relájate y descansa en tu propio paraíso privado con una hermosa piscina de agua salada solo para ti. La villa cuenta con un amplio dormitorio principal y una sala de estar, ambos equipados con aire acondicionado para escapar del calor.
                        </p>
                        <p>
                            ¿Tienes alguna solicitud especial? Estaremos más que encantados de atenderla si podemos. No dudes en hacérnoslo saber.
                            <br />
                        </p>
                        <p>
                            Si necesitas que preparemos una cuna de viaje para tu estadía, por favor infórmanos con anticipación. Nos aseguraremos de colocarla en tu habitación durante nuestro proceso de limpieza.
                            <br />
                        </p>
                        <p>
                            Explora la belleza de Playa Chiquita, Punta Uva y la vibrante cultura de Puerto Viejo, todo mientras cuentas con un hogar comodo al cual regresar. Aprovecha al máximo tu escapada a Puerto Viejo con esta acogedora villa como tu alojamiento.
                            <br />
                        </p>
                        <p>
                            Moverse por Puerto Viejo y sus alrededores es más fácil alquilando una bicicleta o una scooter. Sin embargo, también hay un servicio de autobús público confiable que puede llevarte a Cahuita, Manzanillo y Sixaola. Si prefieres conducir, también podemos coordinar la entrega de vehículos. Ofrecemos estacionamiento privado, pero avísanos si tienes una camioneta grande que requiera espacio adicional.
                            <br />
                        </p>
                    </div>

                    {/* Show OtherListings here only on desktop */}
                    {!isScreenSmall && (
                        <div className="other-listings-bottom">
                            <OtherListingsES listings={VillaCoralSnippet} currentListing={listing || ''} />
                        </div>
                    )}

                </Col>
                <Col id="smoobuComp" className="book col" lg={2} md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 12 }}>
                    {/* Add price and confirmation section above Smoobu */}
                    <PriceConfirmationSection propertyKey="VillaCoral" isSpanish={true} />
                    <Smoobu homeCode={houseData!.houseCode} />
                </Col>
            </Row>

            {/* Show OtherListings here only on mobile - after the entire row */}
            {isScreenSmall && (
                <div className="other-listings-mobile">
                    <OtherListingsES listings={VillaCoralSnippet} currentListing={listing || ''} />
                </div>
            )}
            {show && <ImagesModal closeModal={handleClose} houseName={listing!} />}

            {/* Message Tip Container */}
            <MessageTipContainer />
        </div>
    )

}

export default ListingVillaCoralES;


